import styled from 'styled-components';

const H2 = styled.h2`
  color: #3e465b;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.5;
  margin: 10px 0 5px;
  text-align: left;
`;

export default H2;